import React from 'react';

type Props = {
    className?: string;
    list: {
        anchorLabel?: string;
        label?: string;
        target?: string;
    }[];
};

export default function AnchorLabeledList({ className, list }: Props) {
    return (
        <div>
            {Array.isArray(list) && list.length > 0 && (
                <ul className={`bulleted-list ${className ? className : ''}`}>
                    {list.map((item, index) => (
                        <li key={index}>
                            <a
                                href={item.anchorLabel}
                                target={item.target}
                            >
                                {item.anchorLabel || item}
                            </a>
                            {item.label ? <span className="item-label">{item.label}</span> : null}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}
